import { Table } from "@similarweb/pro-logic-components";

import { useTranslation } from "pro-features/components/WithTranslation";

import { CommonTableTop, CommonTableTopEmpty } from "../../../components/CommonTableTop";
import { STATIC_TABLE_PROPS } from "../../../constants";
import { useSearchFilter } from "../../../hooks/useSearchFilter";
import { useSelectedTrafficSource } from "../../../traffic-sources-tabs";
import { useShareOfWebsiteTrafficData } from "../hooks/useShareOfWebsiteTrafficData";

import { type Data, useColumnsConfig } from "./useColumnsConfig";

export const ShareOfWebsiteTrafficCompetitorsTable = () => {
    const translate = useTranslation();
    const trafficSource = useSelectedTrafficSource();
    const { data, isLoading, excelRowCount } = useShareOfWebsiteTrafficData(trafficSource.value);
    const { data: filteredData, onSearchChange } = useSearchFilter(data);
    const columnsConfig = useColumnsConfig();
    const excelDownloadConfig = {
        url: "/api/benchmark/traffic-channels/share/by-website/excel",
        rowCount: excelRowCount,
    };

    const title = translate("bt.report.channels.share-of-website-traffic-competitors-table.title", {
        trafficName: translate(trafficSource.title),
    });
    const additionalTableProps = filteredData?.length
        ? {
              scroll: { y: 228 },
              style: { height: "258px", overflow: "hidden" },
          }
        : {};

    return (
        <Table<Data>
            {...STATIC_TABLE_PROPS}
            data={filteredData}
            columnConfig={columnsConfig}
            isLoading={isLoading}
            noData={{
                title: translate("global.nodata.notavilable"),
            }}
            {...additionalTableProps}
        >
            {data?.length ? (
                <CommonTableTop
                    excelDownload={excelDownloadConfig}
                    title={title}
                    onSearchChange={onSearchChange}
                />
            ) : (
                <CommonTableTopEmpty title={title} />
            )}
        </Table>
    );
};
